import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getCurrentSubdomain } from '../../commons/domain';

function PrivateRoute({
    component: Component,
    render,
    clientname,
    isLoggedIn,
    ...rest
}) {
    useEffect(() => {
        const isGW = getCurrentSubdomain().indexOf('gw') !== -1
            || (isLoggedIn && clientname === 'Gebrüder Weiss')
            || localStorage.getItem('theme') === 'gw-theme';

        const isDSS = getCurrentSubdomain().indexOf('dss') !== -1
            || (isLoggedIn && clientname === 'DSS')
            || localStorage.getItem('theme') === 'dss-theme';

        document.body.classList.remove(
            'gw-theme',
            'dss-theme'
        );

        if (isGW) {
            document.body.classList.add('gw-theme');
            localStorage.setItem('theme', 'gw-theme');
        } else if (isDSS) {
            document.body.classList.add('dss-theme');
            localStorage.setItem('theme', 'dss-theme');
        } else {
            localStorage.removeItem('theme');
        }

        return () => {
            document.body.classList.remove(
                'gw-theme',
                'dss-theme'
            );
        };
    }, [clientname, isLoggedIn]);

    return (
        <Route
            {...rest}
            render={props =>
                isLogged() === 'true' ? (
                    render ? (
                        render(props)
                    ) : (
                        <Component {...props} />
                    )
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            search: `?redirect_url=${encodeURIComponent(
                                location.pathname + location.search
                            )}`,
                            state: {
                                from: props.location,
                            },
                        }}
                    />
                )
            }
        />
    );
}

PrivateRoute.propTypes = {
    location: PropTypes.object,
    component: PropTypes.func,
    render: PropTypes.func,
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.number.isRequired,
        }),
    }),
    clientname: PropTypes.string,
    isLoggedIn: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]),
};

const isLogged = () => {
    const token = localStorage.getItem('token');

    if (!token || token.length === 0) {
        return 'false';
    }

    return localStorage.getItem('isLoggedIn');
};

const mapStateToProps = (state) => {
    return {
        clientname: state.auth.clientname,
        isLoggedIn: state.auth.isLoggedIn,
    };
};

const ConnectedPrivateRoute = connect(
    mapStateToProps
)(PrivateRoute);

export {
    ConnectedPrivateRoute as PrivateRoute,
};



// WEBPACK FOOTER //
// ./src/shared/PrivateRoute/PrivateRoute.js